// extracted by mini-css-extract-plugin
module.exports = {"delivery__content":"DeliveryInfo_delivery__content__2MDQ4","delivery__accented":"DeliveryInfo_delivery__accented__1lVCW","highlighted":"DeliveryInfo_highlighted__i-j53"};